import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function EditMemo({
  inputRef,
  inputValue,
  setInputValue,
  setIsEdit,
  handleUpdateMemo,
  handleDeleteMemo,
}: {
  inputRef: React.RefObject<HTMLInputElement>;
  inputValue: string;
  setInputValue: (value: string) => void;
  setIsEdit: (value: boolean) => void;
  handleUpdateMemo: () => void;
  handleDeleteMemo: () => void;
}) {
  return (
    <React.Fragment>
      <Input
        ref={inputRef}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        className="w-full h-7 border-dark-red px-2 text-xs font-normal"
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            handleUpdateMemo();
          }
        }}
      />
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="sm"
          className="text-[10px] font-semibold bg-pink text-white"
          onClick={handleDeleteMemo}
        >
          삭제
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setIsEdit(false)}
          className="text-[10px] font-semibold bg-gray-E border-gray-D text-gray-A"
        >
          취소
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={handleUpdateMemo}
          className="text-[10px] font-semibold bg-dark-red text-white"
        >
          저장
        </Button>
      </div>
    </React.Fragment>
  );
}
